import { cx } from '@linaria/core';
import type { ImageProps } from 'next/image';
import Image from 'next/image';
import type { ReactEventHandler } from 'react';

import {
	Level,
	Logger,
	LoggerMessages,
	LoggerServices,
} from '~shared/services/logger';

import { blurredImageStyle, imageStyle, Wrapper } from './styles';

const onLoadError: ReactEventHandler<HTMLImageElement> = (e) => {
	return Logger.shared.log(
		Level.info,
		LoggerServices.ImageLoader,
		LoggerMessages.ImageLoadingError,
		// @ts-ignore
		{ requestUrl: e.target?.currentSrc }
	);
};
const handleLoad: ReactEventHandler<HTMLImageElement> = (e) => {
	(e.target as HTMLImageElement).classList.add('v');
};
export const BlurUpImage = ({
	className,
	src,
	alt,
	width,
	height,
	previewSrc,
	onLoad,
	...restProps
}: ImageProps & {
	previewSrc?: string;
}) => {
	return (
		<Wrapper>
			<Image
				key={`${src as string}blured`}
				className={cx(className, blurredImageStyle)}
				src={previewSrc ?? src}
				width={10}
				height={10}
				alt={alt}
				{...restProps}
				onLoad={(e) => {
					onLoad?.(e);
				}}
			/>
			<Image
				key={src as string}
				className={cx(className, imageStyle)}
				src={src}
				width={width}
				height={height}
				alt={alt}
				onError={onLoadError}
				{...restProps}
				onLoad={(e) => {
					onLoad?.(e);
					handleLoad(e);
				}}
			/>
		</Wrapper>
	);
};
